<app-onb-moldura passo="cardapio" [estado]="estado" [subtitulo]="modo === 'revisar' ? '' : 'Traga o cardápio do jeito mais fácil para você. Tudo pode ser ajustado depois.'">

  <ng-container *ngIf="modo === 'escolher'">
    <div class="pc-portas" id="onb-cardapio-portas">
      <button type="button" class="pc-porta" (click)="importeComIa()">
        <span class="onb-ic onb-ic--cardapio"><i class="fas fa-camera"></i></span>
        <b>Foto ou PDF do cardápio</b>
        <span>A IA lê produtos, preços e categorias. Também aceita texto colado.</span>
        <span class="onb-pill onb-pill--acao">Mais rápido</span>
      </button>
      <button type="button" class="pc-porta" (click)="importeDeOutraPlataforma()">
        <span class="onb-ic onb-ic--loja"><i class="fas fa-link"></i></span>
        <b>Trazer do iFood ou de outra plataforma</b>
        <span>Cole o link da sua loja e trazemos produtos, fotos e preços.</span>
      </button>
      <button type="button" class="pc-porta" (click)="cadastreNaMao()">
        <span class="onb-ic onb-ic--neutro"><i class="fas fa-pen"></i></span>
        <b>Cadastrar na mão</b>
        <span>Só nome, preço e categoria. Comece pelos mais vendidos.</span>
      </button>
    </div>
    <p class="onb-nota">Já mandou o cardápio para a Mia no WhatsApp? Ele aparece aqui sozinho quando ela terminar.</p>
  </ng-container>

  <div class="pc-importador" *ngIf="modo === 'importando'">
    <button type="button" class="onb-btn onb-btn--link pc-voltar" (click)="modo = grupos.length ? 'revisar' : 'escolher'">
      <i class="fas fa-chevron-left"></i> Outras formas de trazer o cardápio
    </button>
    <app-tela-importador-cardapio-ia [embutido]="true" (onConcluido)="aoImportar($event)"></app-tela-importador-cardapio-ia>
  </div>

  <div class="pc-caixa" *ngIf="modo === 'link'">
    <button type="button" class="onb-btn onb-btn--link pc-voltar" (click)="volteParaAsPortas()">
      <i class="fas fa-chevron-left"></i> Outras formas de trazer o cardápio
    </button>

    <ng-container *ngIf="!trazendo">
      <div class="onb-campo">
        <label for="onb-link-loja">Link da sua loja</label>
        <input class="onb-inp" id="onb-link-loja" type="url" [(ngModel)]="link" (keyup.enter)="trazerDoLink()" autocomplete="off"
               placeholder="Ex.: https://www.ifood.com.br/delivery/sua-cidade/sua-loja">
      </div>
      <p class="pc-reconhecido" *ngIf="plataformaDoLink"><i class="fas fa-check-circle"></i> Link do {{ plataformaDoLink.nome }}</p>
      <p class="onb-nota" *ngIf="!plataformaDoLink">
        Funciona com {{ plataformasAceitas }}. Abra sua loja na plataforma, copie o endereço do navegador e cole aqui.
      </p>
      <div class="onb-erro" *ngIf="erroDoLink">
        {{ erroDoLink }}
        <button type="button" class="onb-btn onb-btn--link" (click)="importeComIa()">Usar a foto do cardápio</button>
        <button type="button" class="onb-btn onb-btn--link" (click)="ajuda.emit({passo: 'cardapio', motivo: 'Importar pelo link: ' + erroDoLink})">Pedir ajuda</button>
      </div>
      <div class="onb-acoes" style="margin-top: 14px">
        <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="trazerDoLink()">
          <i class="fas fa-download"></i> Trazer meu cardápio
        </button>
      </div>
    </ng-container>

    <div class="pc-trazendo" *ngIf="trazendo" role="status">
      <b><i class="fas fa-spinner fa-spin"></i> {{ etapaDoLink }}</b>
      <div class="pc-barra" *ngIf="totalDoLink"><span [style.width.%]="progressoDoLink"></span></div>
      <span *ngIf="!totalDoLink">Pode levar um minuto. Não feche esta tela.</span>
      <span *ngIf="totalDoLink">{{ salvosDoLink }} de {{ totalDoLink }} produtos salvos<ng-container *ngIf="falhasDoLink"> · {{ falhasDoLink }} não entraram</ng-container></span>
    </div>
  </div>

  <div class="pc-caixa" *ngIf="modo === 'manual'">
    <button type="button" class="onb-btn onb-btn--link pc-voltar" (click)="volteParaAsPortas()">
      <i class="fas fa-chevron-left"></i> Outras formas de trazer o cardápio
    </button>
    <div class="pc-manual">
      <div class="onb-campo pc-campo--nome">
        <label for="onb-manual-nome">Produto</label>
        <input class="onb-inp" id="onb-manual-nome" [(ngModel)]="manual.nome" placeholder="Ex.: X-Burger" maxlength="120"
               (keyup.enter)="adicioneNaMao()">
      </div>
      <div class="onb-campo">
        <label for="onb-manual-preco">Preço</label>
        <div class="onb-prefixo">
          <span>R$</span>
          <input class="onb-inp" id="onb-manual-preco" [(ngModel)]="manual.preco" inputmode="decimal" placeholder="0,00"
                 (keyup.enter)="adicioneNaMao()">
        </div>
      </div>
      <div class="onb-campo">
        <label for="onb-manual-categoria">Categoria</label>
        <input class="onb-inp" id="onb-manual-categoria" [(ngModel)]="manual.categoria" list="onb-categorias" placeholder="Ex.: Lanches"
               maxlength="80" (keyup.enter)="adicioneNaMao()">
        <datalist id="onb-categorias"><option *ngFor="let c of categorias" [value]="c"></option></datalist>
      </div>
    </div>
    <div class="onb-erro" *ngIf="erroManual">{{ erroManual }}</div>
    <div class="onb-acoes" style="margin-top: 10px">
      <button type="button" class="onb-btn onb-btn--sec" (click)="adicioneNaMao()">
        <i class="fas" [class.fa-plus]="!salvandoManual" [class.fa-spinner]="salvandoManual" [class.fa-spin]="salvandoManual"></i>
        Adicionar produto
      </button>
    </div>
    <ng-container *ngIf="adicionados.length">
      <div class="onb-grupo-rot">Adicionados agora</div>
      <div class="onb-grupo">
        <div class="onb-linha" *ngFor="let a of adicionados">
          <div class="onb-tx"><b>{{ a.nome }}</b></div>
          <span class="pc-valor">R$ {{ a.preco.toFixed(2).replace('.', ',') }}</span>
          <i class="fas fa-check pc-ok"></i>
        </div>
      </div>
    </ng-container>
    <p class="onb-nota">Foto, descrição e adicionais você coloca depois, em Produtos.</p>
  </div>

  <ng-container *ngIf="modo === 'revisar'">
    <div class="onb-erro" *ngIf="erro">{{ erro }} <button type="button" class="onb-btn onb-btn--link" (click)="carregueRevisao()">Tentar de novo</button></div>
    <p class="onb-sub" *ngIf="carregando">Carregando seus produtos…</p>

    <ng-container *ngIf="!carregando && grupos.length">
      <p class="onb-sub">
        Você tem <b>{{ produtos.length }} {{ produtos.length === 1 ? 'produto' : 'produtos' }}</b>.
        <span class="onb-pill onb-pill--aviso" *ngIf="semPreco">{{ semPreco }} sem preço</span>
        <span class="onb-pill onb-pill--ok" *ngIf="!semPreco">Todos com preço</span>
      </p>
      <p class="onb-nota" style="margin-top: 2px">Produto sem preço fica escondido da loja até você preencher. O preço salva sozinho ao sair do campo.</p>

      <ng-container *ngFor="let g of grupos">
        <div class="onb-grupo-rot">{{ g.categoria }}</div>
        <div class="onb-grupo">
          <div class="onb-linha pc-produto" *ngFor="let p of g.produtos" [class.pc-produto--falta]="semPrecoNoProduto(p)">
            <div class="onb-tx">
              <b>{{ p.nome }}</b>
              <span *ngIf="p.descricao">{{ p.descricao }}</span>
              <span class="pc-erro" *ngIf="p.erro">{{ p.erro }}</span>
            </div>
            <ng-container *ngIf="!p.tamanhos">
              <div class="onb-prefixo pc-preco">
                <span>R$</span>
                <input class="onb-inp" [id]="'onb-preco-' + p.id" [class.falta]="semPrecoNoProduto(p)" [(ngModel)]="p.precoTexto" inputmode="decimal"
                       placeholder="0,00" [attr.aria-label]="'Preço de ' + p.nome" (blur)="salvePreco(p)" (keyup.enter)="salvePreco(p)">
              </div>
              <span class="pc-estado">
                <i class="fas fa-spinner fa-spin" *ngIf="p.salvando"></i>
                <i class="fas fa-check" *ngIf="p.salvo"></i>
              </span>
            </ng-container>
            <button type="button" class="onb-btn onb-btn--sec" *ngIf="p.tamanhos" (click)="abraEditor(p)">
              Preços por tamanho <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </ng-container>

      <div class="onb-acoes" style="margin-top: 12px">
        <button type="button" class="onb-btn onb-btn--link" (click)="modo = 'escolher'"><i class="fas fa-plus"></i> Trazer mais produtos</button>
        <a class="onb-btn onb-btn--link" routerLink="/admin/produtos-v2">Fotos, adicionais e tamanhos ficam em Produtos</a>
      </div>
    </ng-container>
  </ng-container>

  <div class="onb-rodape" *ngIf="modo !== 'importando' && modo !== 'link'">
    <span class="onb-dica" *ngIf="modo === 'revisar' && comPreco">{{ comPreco }} {{ comPreco === 1 ? 'produto vai' : 'produtos vão' }} aparecer na loja</span>
    <span class="onb-dica" *ngIf="modo === 'manual' && adicionados.length">{{ adicionados.length }} {{ adicionados.length === 1 ? 'produto vai' : 'produtos vão' }} aparecer na loja</span>
    <span class="onb-dica" *ngIf="(modo !== 'revisar' || !comPreco) && !(modo === 'manual' && adicionados.length)">Precisa de ao menos um produto com preço</span>
    <a class="onb-btn onb-btn--link" routerLink="/admin/comecar">Fazer depois</a>
    <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="conclua()">
      Salvar e continuar
    </button>
  </div>
</app-onb-moldura>
